import { useEffect } from "react";
import { useErrorToastStore } from "../../store/errorToastStore";

export function ErrorToast() {
  const message = useErrorToastStore((s) => s.message);
  const clearError = useErrorToastStore((s) => s.clearError);

  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(clearError, 4000);
    return () => clearTimeout(timer);
  }, [message, clearError]);

  if (!message) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      data-testid="error-toast"
      tabIndex={0}
      onClick={clearError}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") clearError();
      }}
      style={{
        position: "fixed",
        bottom: 72,
        left: 16,
        zIndex: 3000,
        cursor: "pointer",
        background: "var(--bg-elevated)",
        borderLeft: "3px solid var(--destructive)",
        borderRadius: 8,
        padding: "10px 14px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        maxWidth: 280,
        minWidth: 200,
        fontSize: 13,
        color: "var(--destructive)",
        fontWeight: 600,
      }}
    >
      {message}
    </div>
  );
}

export default ErrorToast;
